import { render, staticRenderFns } from "./SliderStudents.vue?vue&type=template&id=670d1320&scoped=true&"
import script from "./SliderStudents.vue?vue&type=script&lang=js&"
export * from "./SliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./SliderStudents.vue?vue&type=style&index=0&id=670d1320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d1320",
  null
  
)

export default component.exports